<template>
    <section>
        <b-form-group
            :invalid-feedback="errors?.first_name"
            :state="!errors?.first_name"
        >
            <b-input v-model="firstName" :placeholder="$t('register.firstName')"></b-input>
        </b-form-group>
        <b-form-group
            :invalid-feedback="errors?.last_name"
            :state="!errors?.last_name"
        >
            <b-input v-model="lastName" :placeholder="$t('register.lastName')"></b-input>
        </b-form-group>
        <b-form-group
            :invalid-feedback="errors?.email"
            :state="!errors?.email"
        >
            <b-input v-model="email" :placeholder="$t('register.email')"></b-input>
        </b-form-group>
        <b-form-group
            :state="!errors?.country_code"
            :invalid-feedback="errors?.country_code"
        >
            <countries v-model="countryCode"></countries>
        </b-form-group>
        <b-form-group
            style="margin-top: 2rem;"
            :invalid-feedback="errors?.password"
            :state="!errors?.password"
        >
            <b-input v-model="password" type="password" :placeholder="$t('register.password')"></b-input>
            <b-input v-model="passwordConfirm" type="password" class="mt-2"></b-input>
        </b-form-group>
        <align-right class="mt-3 mb-3">
            <b-button block variant="primary" @click="register">
                {{ $t('register.createAccount') }}
                <b-spinner small v-if="loading"></b-spinner>
            </b-button>
        </align-right>
    </section>
</template>
<script>
import { defineComponent } from 'vue';
import AlignRight from '@components/Layout/AlignRight.vue';
import { api } from '@services/AxiosBootstrap';
import Divider from '@components/Divider.vue';
import Countries from '@components/Form/Countries.vue';

export default defineComponent({
    components: { Countries, Divider, AlignRight },
    data() {
        return {
            loading: false,
            errors: null,
            firstName: null,
            lastName: null,
            email: null,
            password: null,
            passwordConfirm: null,
            countryCode: null,
        };
    },
    methods: {
        handleUpdate(event) {
            this.$emit('update', event);
        },
        async register() {
            this.errors = null;
            try {
                this.loading = true;
                const response = await api.post('/auth/register', {
                    first_name: this.firstName,
                    last_name: this.lastName,
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.passwordConfirm,
                    country_code: this.countryCode?.id,
                    website: window.location.host,
                });

                if (response.status === 200) {
                    const data = response.data.data;
                    this.handleUpdate({ user: data.user, auth: data.auth });
                }
            } catch (e) {
                this.errors = e.response.data.errors;
            }
            this.loading = false;
        },
    },
});
</script>
